module.exports = __webpack_public_path__ + "img/click_tab2_mobile.435efb42.png";